import { IClient } from './IClient';
import { IInvoice } from './IInvoice';
import { IOfferPosition } from './IOfferPosition';
import { IProject } from './IProject';

export enum OfferStatus {
  DRAFT = 'draft',
  ACCEPTED = 'accepted',
  OPEN = 'open',
  FINISHED = 'finished',
  CANCELLED = 'cancelled',
}

export enum OfferType {
  FIXEDPRICE = 'fixedPrice',
  PERIODICEXPENSES = 'periodicExpenses',
  PERIODICFIXEDPRICE = 'periodicFixedPrice',
}

export interface IOffer {
  offerId: string;
  title?: string;
  projectId?: number;
  clientId?: number;
  contractNumber?: string;
  PM?: number;
  DEV?: number;
  status?: OfferStatus;
  offerCreateDate: string;
  offerTimeFrom: string;
  offerTimeTo: string;
  offerValue: number;
  openBudget?: string;
  discount?: number;
  orderDate: string;
  invoiceToEmail?: string;
  invoiceToEmailCc?: string;
  invoiceToName?: string;
  invoiceToStreet?: string;
  invoiceToCity?: string;
  invoiceToCountryCode?: string;
  invoiceToPostalCode?: string;
  comment?: string;
  validTo: string;
  rateFrom: string;
  filename?: string;
  deleted: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  project?: IProject;
  offerPositions?: IOfferPosition[];
  invoices?: IInvoice[];
  client?: IClient;
  totalAmountInvoiced?: number | null;
  invoiceCount?: number | null;
}

export interface IOfferFilter {
  search?: string | null;
  status?: string | null;
  createDate?: string;
  sortedBy?: string;
  sortedOrder?: 'ASC' | 'DESC';
}
